import { render } from "./Aziende.vue?vue&type=template&id=7803f75e&scoped=true"
import script from "./Aziende.vue?vue&type=script&lang=js"
export * from "./Aziende.vue?vue&type=script&lang=js"

import "./Aziende.vue?vue&type=style&index=0&id=7803f75e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7803f75e"]])

export default __exports__